import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { AlertTriangle } from "lucide-react";
 * // Use <AlertTriangle /> instead
 */
export const WarningIcon = createSVGWrapper(
  <path
    fill="currentColor"
    d="M12.8762 2.59313C12.4963 1.90235 11.5037 1.90235 11.1238 2.59313L1.81504 19.5181C1.44846 20.1845 1.93064 21 2.69126 21H21.3087C22.0693 21 22.5515 20.1845 22.1849 19.5181L12.8762 2.59313ZM11 8H13V14H11V8ZM11 16H13V18H11V16Z"
    fillRule="evenodd"
    clipRule="evenodd"
  />
);
